const TeamList = [

    {

        Avatar: "/new/boss.jpg",
        Name: "Hon.  Dr. Uriel Ezeh",
        icon: "fas fa-star",
        Position: "Group Managing Director",
        About: "Hon. Dr. Uriel A. Ezeh (ILM) is the Founder and Group Chief Executive Officer of UR9 GROUP. A multi-talented business tycoon, he has overseen the growth and expansion of the UR9 brand into one of the foremost premium luxury brands in the country.A graduate of Business and Management from the University of Sunderland and a dual Master's holder of Management and Leadership; Global Management from the prestigious Regent's Business School, London.The Honourable Doctor Uriel has shown himself to be a serial entrepreneur with the gift of discerning times and seasons; a gift from God he acknowledges as one of the foundations of success of the UR9 Group.",
        member: "Fellow: Institute of Chartered Administrators and Researchers of Nigeria." ,
        button: "Read More"

    },

    {

        Avatar: "/new/CFO.JPG",
        Name: "Glory Adeniyi",
        icon: "fas fa-star",
        Position: "Deputy Managing Director(DMD)",
        About: "Miss Glory C. Adeniyi is the Deputy Managing Director of UR9 Group. She is a graduate of Ladoke Akintola University of Technology (LAUTECH). She graduated with a Bachelor of Technology in Agronomy. She worked as a Field Supervisor/Research Assistant at the International Institute of Tropical Agriculture (IITA) before going on to work as an Admin / Human Resource Officer at Leadway Assurance Company. She also worked at the Nigerian National Assembly (NASS) as the Legislative Aide to the Deputy President of the Senate before going on to assume her position at UR9 Group. "  +

          "She gained valuable leadership as well as administrative experience from herbdofferent roles and those experiences as well as her keen eye for detail and ability to see potential business opportunities even before they develop have helped shape her into the business icon she is today."

    },


    {

        Avatar: "/new/hr.JPG",
        Name: "Sandra Udeji",
        icon: "fas fa-star",
        Position: "HR/GM",
        About: "Miss Sandra Udeji is a highly experienced and accomplished Human Resource professional and Operations Manager at UR9, holding a degree in Bio-Technology from Godfrey Okoye University. " +
            "A member of chattered Institute of Human Resources management Nigeria and boasting an impressive track record as a Human Resource Assistant at the National Office for Technology Acquisition and Promotion." +
            " With three certifications in Human Resource Management, Human Resource Diploma, and Project Management. Sandra brings a unique blend of strategic insight, operational expertise, and leadership acumen to her role,skillfully " +
            " managing all aspects of Human Resources and overseeing the overall operations of the company with precision and finesse, driving efficiency, productivity, and success at UR9."

    },





    {

        Avatar: "/Agnes.jpeg",
        Name: "Shimaor Dowgo Avadoo",
        icon: "fas fa-star",
        Position: "Site Manager and Estate Surveyor",
        About: "Shimaor Dowgo Avadoo, a seasoned real estate professional and licensed estate surveyor with" +
            " a PGD in Facilities Management and Certification in Project Management, in the construction" +
            " division at UR9 Group as site manager driving growth and success through her expertise in" +
            " property valuation, market analysis, project management, and team leadership while overseeing" +
            " strategic planning, project execution, and site operations, and fostering long-term relationships" +
            " with clients, partners, and stakeholders."


    },






    {

        Avatar: "/new/fashion.jpg",
        Name: "Miss Anthonia E. Imana",
        icon: "fas fa-star",
        Position: "Fashion Supervisor",
        About: "Miss Anthonia E. Imana is an Insightful and highly experienced and accomplished supervisor in the fashion space, " +
        "worked in various fashion Houses before joining the UR9 group. A supervisor within processing and improving operations through " +
       " effective employee motivational strategies. Proficient in best practices, market trends and regulatory requirements of industry operations. " +
       " With B.sc from the prestigious Ambrose Alli University with a proven track record of leading high performing team and meeting customers needs adequately."
    },

    {

        Avatar: "/new/bmo.jpg",
        Name: "Chidiogo M. Udebuani",
        icon: "fas fa-star",
        Position: "Business Development Manager, UR9 Group",
        About: "C. M. Udebuani is a results-driven Business Developer, a Certified Projects Manager, and a renowned Computer Scientist (master's and bachelor's degrees from the estimable University of Abuja and Nnamdi Azikiwe University, Awka, respectively). She has a strong record of excellence in technology-driven organizational growth and innovation. Skilled in leveraging advanced analytical, managerial, and strategic planning competencies to deliver complex projects efficiently and drive sustainable business expansion. Also certified in HRM, CRM, ACLRC & HSE. Adept at aligning technical solutions with corporate objectives, optimizing processes, and leading cross-functional teams to achieve measurable outcomes. Recognized for exceptional leadership, strategic foresight, and the ability to bridge the gap between technology, management, and market development."
    },

    {

        Avatar: "/new/HOD.jpg",
        Name: "Vitalis Emmanuel",
        icon: "fas fa-star",
        Position: "Head of Media, UR9 Group",
        About: "Vitalis Emmanuel is a creative brand developer, project manager, and media expert with a passion for crafting powerful visual stories. As Head of Media at UR9 Group, he has led numerous branding and media projects, producing over 1,000 visuals for companies and organizations. A Computer Science graduate from Cross River State University of Technology, he is currently pursuing a Master's degree in Information Technology. Vitalis is also a movie director who has directed several brand stories, documentaries, and music videos showcasing his versatility and creative depth. A member of the Media Practitioners Association of Nigeria, he is skilled in digital marketing, PR, and multimedia production. With a consistent record of excellence and innovation, his mission is to strengthen UR9 Group's brand presence and position its diverse businesses as industry leaders."
    },

    {

        Avatar: "/new/account.png",
        Name: "Emeto Cynthia Onyinye",
        icon: "fas fa-star",
        Position: "Accountant, UR9 Group",
        About: "Emeto Cynthia Onyinye is a skilled and detail oriented accountant at UR9 Group, with a strong background in financial accounting, auditing, and data management. She holds a B.Sc. in Accounting from Imo State University and has gained valuable experience working as both a Financial Accountant and an Auditor in reputable organizations. Cynthia is proficient in using accounting software and data entry systems, which helps her maintain accurate financial records, support effective budgeting, and ensure compliance with organizational policies. She has a keen interest in taxation, finance, and business development, and plans to further her professional qualifications by pursuing certifications with the Institute of Chartered Accountants of Nigeria (ICAN) and the Chartered Institute of Taxation of Nigeria (CITN). Cynthia is passionate about promoting financial integrity, accountability, and helping organizations make sound financial decisions that drive growth and sustainability."
    },

    {

        Avatar: "/new/logistics.png",
        Name: "Simon Daniel E.",
        icon: "fas fa-star",
        Position: "Logistics Supervisor, UR9 Group",
        About: "He brings a wealth of experience and professionalism to the company's operations both internally and externally. With an extensive background working with several reputable firms across the logistics and supply chain sector. He has established himself as a dependable leader known for his efficiency, organization and results oriented approach. He oversees all aspects of logistics planning and execution including transportation management, fleet coordination, inventory control and distribution. He holds a Diploma in Accounting from Ahmadu Bello University, Zaria and presently pursuing a degree in Business Administration at the National Open University of Nigeria."
    },




]

export default TeamList;
